<template>
  <div>
    <div class="totalPie">
      <div class="tit">
        <p>修复跟踪</p>
      </div>
      <div class="Piebar" id="rbar"></div>
      <div class="imagesss">
        <div class="xiufu">
          <p>修复前照片</p>
          <a :href="before[0].urlHttp" target="_blank"><img :src="before[0].urlHttp" class="qdimg" /></a>
        </div>
        <div class="jiantou"></div>
        <div class="xiufu">
          <p>修复后照片</p>
          <a :href="after[0].urlHttp" target="_blank"><img :src="after[0].urlHttp" class="qdimg" /></a>
        </div>
      </div>
      <div class="fzrInfo">
        <img src="../../common/images/fxxc.png" class="fzrimg" />
        <p>相关责任人:</p>
        <p>{{obj.ydbZrr}}</p>
        <div class="fenjiex"></div>
        <p>{{obj.ydbTbdw}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { shgcxfList } from "@/api/api.js";
export default {
  props: ["gisclick"],
  data() {
    return {
      obj: {
        ydbZrr: "-",
        ydbTbdw: "-",
      },
      before: [""],
      after: [""],
    };
  },
  watch: {
    gisclick(a) {
      if (a.ydbCode) {
        let params = { ydbCode: a.ydbCode };
        this.shgcxfListReq(params);
      }
    },
  },
  mounted() {},
  methods: {
    shgcxfListReq(params) {
      var that = this;
      shgcxfList(params).then((res) => {
        if (res.data[0] == undefined) return;
        that.obj = res.data[0];
        that.before = that.obj.ydbXfqZp;
        that.after = that.obj.ydbXfhZp;
        this.bar();
      });
    },
    bar() {
      let bar = this.$echarts.init(document.getElementById("rbar"));
      var that = this;
      let option = {
        grid: {
          containLabel: true,
          show: false,
          right: "5%",
          left: 0,
          bottom: "5%",
          top: "5%",
        },
        xAxis: {
          type: "time",
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.5)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              fontFamily: "Microsoft YaHei",
            },
          },
        },
        yAxis: {
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.5)",
            },
          },
          axisLabel: {
            show: true,
            interval: 0,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
          data: ["水毁时间", "当前", "修复截止"],
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            //偶数
            var start0 = params[1].data;
            var start =
              start0.getFullYear() +
              "-" +
              (start0.getMonth() + 1) +
              "-" +
              start0.getDate();
            return start;
          },
        },
        series: [
          {
            name: "任务时间",
            type: "bar",
            stack: "总量3",
            barWidth: 10,
            itemStyle: {
              normal: {
                color: "#098dc7",
                borderWidth: 0,
              },
            },
            zlevel: -1,
            data: [
              new Date(new Date(that.obj.ydbShsj).getTime() + 86400000),
              new Date(new Date().getTime() + 86400000),
              new Date(new Date(that.obj.ydbXfjzSj).getTime() + 86400000),
            ],
          },
          {
            name: "任务时间",
            type: "bar",
            stack: "总量3",
            barWidth: 10,
            itemStyle: {
              normal: {
                color: "rgba(25,46,65,1)",
                borderColor: "rgba(25,46,65,1)",
                borderWidth: 0,
              },
            },
            zlevel: -1,
            z: 3,
            data: [
              new Date(that.obj.ydbShsj),
              new Date(),
              new Date(that.obj.ydbXfjzSj),
            ],
          },
        ],
      };

      bar.setOption(option);
    },
  },
};
</script>

<style scoped>
.totalPie {
  width: 100%;
  height: 540px;
  background: url(../../common/images/contentborder.png) no-repeat center;
  background-size: 100% 100%;
  margin-top: 15px;
}

.tit {
  padding-bottom: 10px;
  border-bottom: 1px solid #098dc7;
}

.tit p {
  margin-top: 15px;
}

.Piebar {
  width: 90%;
  margin: 0 auto;
  height: 300px;
}

.imagesss {
  width: 90%;
  margin: 0 auto;
  height: 130px;
}

.xiufu {
  float: left;
  width: 45%;
  height: 100%;
}

.xiufu p {
  text-align: center;
  color: #fff;
  margin-top: 5px;
  margin-bottom: 5px;
}

.jiantou {
  width: 10%;
  height: 100%;
  float: left;
}

.qdimg {
  width: 100%;
  height: calc(100% - 20px);
}

.fzrInfo {
  width: 90%;
  margin: 0 auto;
  margin-top: 15px;
  height: 30px;
  background-color: rgba(51, 198, 96, 0.2);
  border: 1px solid rgba(51, 198, 96, 1);
}

.fzrimg {
  float: left;
  width: 20px;
  height: 20px;
  margin-top: 5px;
  margin-left: 40px;
}

.fzrInfo p {
  float: left;
  color: white;
  margin-left: 5px;
  line-height: 30px;
}

.fenjiex {
  float: left;
  width: 1px;
  height: 10px;
  margin-top: 10px;
  margin-left: 15px;
  margin-right: 10px;
  border-right: 2px solid rgba(51, 198, 96, 1);
}
</style>
